<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">
          Delete Medication
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <p class="text-body-1">
            Are you sure you want to delete this medication? This action cannot be undone.
          </p>
          <p v-if="medication" class="text-body-2 mt-2 font-weight-medium">
            Medication: {{ medication.medication_name }}
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            variant="text"
            @click="handleClose"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            variant="flat"
            :disabled="loading"
            :loading="loading"
            @click="handleDelete"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_master_medications } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: 'DeleteMedicationDialog',
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    medication: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'deleted'],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    }
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        // Reset when dialog closes
      }
    }
  },
  methods: {
    handleClose() {
      this.dialog = false
    },
    async handleDelete() {
      this.loading = true

      try {
        const input = {
          medication_master_id: this.medication.medication_master_id || this.medication.id || '',
          medication_status: 'DEACTIVE'
        }
        
        const response = await client.graphql({
          query: edit_master_medications,
          variables: {
            input: input,
          },
        })
        
        // console.log(response)
        const responseData = JSON.parse(response.data.edit_master_medications)
        
        if (responseData.status == "SUCCESS") {
          this.loading = false
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Medication deleted successfully",
            color: "success",
          }
          this.$emit('deleted', 0)
          this.handleClose()
        } else {
          this.loading = false
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Failed to delete medication",
            color: "error",
          }
        }
      } catch (error) {
        this.loading = false
        console.error('Error deleting medication:', error)
        this.snackbar = {
          show: true,
          message: error.message || "Failed to delete medication",
          color: "error",
        }
      }
    }
  }
}
</script>

<style scoped>
</style>

